import React from "react";
import { Link } from "react-router-dom";
import { services } from "../mock";
import { ShieldCheck, Star, Trash2, Radar, ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "../components/ui/button";

const icons = { ShieldCheck, Star, Trash2, Radar };

export default function ServicesPage() {
  return (
    <>
      <section className="bg-gradient-to-b from-slate-50 to-white py-16 md:py-20 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">Our services</div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0B2447] tracking-tight max-w-3xl">A complete toolkit to protect and grow your reputation</h1>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl leading-relaxed">From day-to-day review management to defamatory content removal, our specialists cover every corner of your brand's digital reputation.</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-6">
          {services.map((s, i) => {
            const Icon = icons[s.icon] || ShieldCheck;
            return (
              <div key={s.slug} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 items-center rounded-3xl border border-slate-200 bg-white p-8 md:p-12 ${i % 2 ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <div className="lg:col-span-7">
                  <div className="w-12 h-12 rounded-xl bg-[#0B2447]/5 flex items-center justify-center mb-5">
                    <Icon className="w-6 h-6 text-[#0B2447]" />
                  </div>
                  <div className="text-xs uppercase tracking-widest text-slate-500">{s.tagline}</div>
                  <h2 className="mt-1 text-2xl md:text-3xl font-bold text-[#0B2447]">{s.title}</h2>
                  <p className="mt-3 text-slate-600 leading-relaxed max-w-xl">{s.desc}</p>
                  <ul className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-start gap-2 text-sm text-slate-700"><CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" /> {f}</li>
                    ))}
                  </ul>
                  <Link to="/contact" className="inline-block mt-8">
                    <Button className="bg-[#0B2447] hover:bg-[#122e5f] text-white h-11 px-5">
                      Get a free assessment <ArrowRight className="ml-2 w-4 h-4" />
                    </Button>
                  </Link>
                </div>
                <div className="lg:col-span-5">
                  <div className="aspect-[4/3] rounded-2xl bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200 p-6 flex items-center justify-center">
                    <div className="text-center">
                      <Icon className="w-14 h-14 text-[#0B2447] mx-auto" />
                      <div className="mt-4 text-sm uppercase tracking-widest text-slate-500">{s.tagline}</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-20 bg-[#0B2447] text-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight">Not sure which service is right for you?</h2>
          <p className="mt-4 text-slate-300 max-w-xl mx-auto">Speak to a reputation specialist and get a tailored plan in 15 minutes. No obligation.</p>
          <Link to="/contact" className="inline-block mt-8">
            <Button className="bg-white text-[#0B2447] hover:bg-slate-100 h-12 px-6 text-base">Book a free consultation</Button>
          </Link>
        </div>
      </section>
    </>
  );
}
